// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"c78421df","275":"425c4591","347":"5ade7d8d","394":"ae4bddc1","524":"a0bed53d","656":"edfd75c8","753":"fe2837bf","754":"f8bbd69e"}[chunkId] + ".chunk.js";
};